import api from '../api/instance';
import { Page, KibbutzTestDataFunction } from '@testsigmainc/models';
import { PrivateURLConstants } from '@constants/private-url.constant';

const nameSpace = PrivateURLConstants.KIBBUTZ;

const findAllFunctions = (filterQuery?) => {
  return api
    .get(`${nameSpace}/test_data_functions` + (filterQuery ? filterQuery : ''))
    .then((res) =>
      new Page<KibbutzTestDataFunction>().deserialize(
        res,
        KibbutzTestDataFunction,
      ),
    )
    .catch((e) => Promise.reject(e));
};

const showFunction = (functionId: number) => {
  return api
    .get(`${nameSpace}/test_data_functions/` + functionId)
    .then((res) => new KibbutzTestDataFunction().deserialize(res))
    .catch((e) => Promise.reject(e));
};

const KibbutzService = {
  findAllFunctions,
  showFunction,
};

export default KibbutzService;
